export default {
  deployTrend: {
    title: 'Deploy Trend',
    warning: 'Warning',
    thisMonth: 'this month',
    thisWeek: 'this week',
    lastMonth: 'last month',
    thisYear: 'this year',
    lastYear: 'last year',
    week1: 'MON',
    week2: 'TUE',
    week3: 'WED',
    week4: 'THU',
    week5: 'FRI',
    week6: 'SAT',
    week7: 'SUN',
  },
  projectList: {
    title: 'Project List',
    dialog: {
      title: 'Base Info',
    },
    table: {
      name: 'Name',
      admin: 'Admin',
      createTime: 'Create time',
      operation: 'Operation',
      manage: 'manage',
      delete: 'delete',
    },
  },
};
